import { render, staticRenderFns } from "./DurationSpan.vue?vue&type=template&id=3e7e621f&"
import script from "./DurationSpan.vue?vue&type=script&lang=js&"
export * from "./DurationSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports